import { render, staticRenderFns } from "./ProductHelp.vue?vue&type=template&id=bbe6c636&"
import script from "./ProductHelp.vue?vue&type=script&lang=js&"
export * from "./ProductHelp.vue?vue&type=script&lang=js&"
import style0 from "./ProductHelp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports